import React, { forwardRef } from 'react';
import { c as classnames } from './index-2586sEvh.js';
import get from 'lodash/get';
import { useTranslation } from 'next-i18next';

const Input = forwardRef(({ register, id = '', errors, variant = 'stacked', type = 'text', name, label = '', ariaLabel = '', disabled, placeholder = '', autocomplete, inputMode = 'text', filled = false, maxLength = 0, charactersMinLength, pattern, onBlur, onFocus, }, ref) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    const { ref: inputRef, ...rest } = register(name);
    // handleInputChange is disabled until we confirm this will not cause issues with react-hook-form
    // const [inputValue, setInputValue] = useState('');
    // const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    //   if (type === 'tel') {
    //     const updatedValue = event.target.value.replace(/[^0-9]/g, '');
    //     setInputValue(updatedValue);
    //   } else {
    //     setInputValue(event.target.value);
    //   }
    // };
    return (React.createElement("div", { className: `form-control ${variant}-input` },
        React.createElement("label", { htmlFor: id, className: classnames('label', { hide: !label }) }, label || placeholder),
        React.createElement("div", { className: "form-control-wrapper" },
            React.createElement("input", { ref: e => {
                    inputRef(e);
                    if (ref) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        // eslint-disable-next-line no-param-reassign
                        ref.current = e;
                    }
                }, ...rest, type: type, disabled: disabled, placeholder: placeholder, autoComplete: autocomplete, id: id, "data-testid": id, className: classnames('input', filled && 'filled', { error: isError }), "aria-label": ariaLabel || label || placeholder, "aria-invalid": isError ? 'true' : 'false', "aria-describedby": isError ? `${id}Error` : undefined, inputMode: inputMode, maxLength: maxLength || null, pattern: pattern, onBlur: onBlur, onFocus: onFocus }),
            isError && (React.createElement("div", { className: "error", id: `${id}Error`, role: "alert" }, t(errorText, { amount: charactersMinLength }))))));
});
Input.displayName = 'Input';

export { Input as I };
//# sourceMappingURL=Input-NDT6doB1.js.map
